import { Capitalize } from '@/common/filters/capitalize';
import { ReplaceVariableByUser } from '@/common/filters/replace-variable-by-user';
import { StageDateHint } from '@/common/filters/stage-date-hint';
import Vue from 'vue';

Vue.filter('capitalize', Capitalize);
Vue.filter('stageDateHint', StageDateHint);
Vue.filter('replaceVariableByUser', ReplaceVariableByUser);
